import { Ref } from "react";

import FormInputWrapper, {
  FormInputWrapperProps,
} from "../FormInputWrapper/FormInputWrapper";

import styles from "./FormTextarea.module.css";

const FormTextarea: React.FC<FormTextareaProps> = ({ inputRef, ...props }) => {
  return (
    <FormInputWrapper {...props}>
      <textarea className={styles.textarea} ref={inputRef} />
    </FormInputWrapper>
  );
};

export default FormTextarea;

export type FormTextareaProps = {
  inputRef?: Ref<HTMLTextAreaElement>;
} & FormInputWrapperProps &
  React.HTMLProps<HTMLInputElement>;
